// Text pasted from websites, PDFs, emails and spreadsheets often carries characters you can't see:
// zero-width spaces, non-breaking spaces, "smart" dashes, full-width letters, line breaks.
// A pasted part number then looks right but matches nothing. This turns it back into plain text.
export function cleanPasted(s: unknown): string {
  return String(s ?? '')
    .normalize('NFKC')
    .replace(/[​-‏‪-‮⁠-⁤﻿­]/g, '')
    .replace(/[‐-―−﹘﹣－]/g, '-')
    .replace(/[\r\n\t  -   　]+/g, ' ');
}
/** "WAB 441-030 905.2", "#wab4410309052" and "wab-441-030" (any dash) are the same part number. */
export const partKey = (s: unknown) => cleanPasted(s).toLocaleLowerCase().replace(/[\s\-./_#"'`‘’“”]/g, '');

/** Dealer line code in front of a part # ("007F/SP 350CB03X", "DDE A0159974946") — Fullbay and dealer invoices add it. */
export const stripDealer = (s: unknown) => String(s ?? '').trim().replace(/^[0-9][0-9A-Z]{2,4}\s*\/\s*/i, '').replace(/^(DDE|DTNA|FLT|FTL)\s+(?=[A-Z0-9-]*\d)/i, '');
/** Same part # with or without the dealer code, spaces or dashes. */
export const bareKey = (s: unknown) => partKey(stripDealer(s));
/** Part # as the customer sees it: no dealer code; a word that isn't a part # ("Clutch", "Clamp") is not shown. */
export const customerSku = (s: unknown) => { const x = stripDealer(s); return /\d/.test(x) && x.length >= 3 ? x : ''; };
